import { render, staticRenderFns } from "./VideoJs.vue?vue&type=template&id=56942062&scoped=true"
import script from "./VideoJs.vue?vue&type=script&lang=js"
export * from "./VideoJs.vue?vue&type=script&lang=js"
import style0 from "./VideoJs.vue?vue&type=style&index=0&id=56942062&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56942062",
  null
  
)

export default component.exports